import {action} from 'typesafe-actions';
import {FaqActionTypes, IFaqState} from './faq.types';

export const setFaq = (payload: IFaqState) => action(FaqActionTypes.SET, {payload});
